import React from "react";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrIcon } from "@maven-surface/components/base/CrIcon";
import { IconName } from "@maven-surface/components/interface/Icon";

interface HbButtonProps {
  elementRef?: React.RefObject<HTMLButtonElement>;
  text: string | React.ReactNode;
  size?: "LARGE" | "X-LARGE" | "2X-LARGE" | "3X-LARGE" | "4X-LARGE" | "5X-LARGE" | "6X-LARGE" | "7X-LARGE" | "8X-LARGE";
  className?: string;
  useTextUnderline?: boolean;
  disabled?: boolean;
  color: "PRIMARY" | "DANGER" | "SUCCESS" | "WARNING" | "TRANSPARENT";
  iconLeft?: IconName;
  iconRight?: IconName;
  marginTop?: -1;
  onClick?: () => void;
}

export function HbButton(props: HbButtonProps) {
  const { className, color, marginTop, text, size, iconLeft, iconRight, onClick, useTextUnderline, disabled, elementRef } = props;

  return (
    <div
      tabIndex={-1}
      className={classNames(
        "hb-button",
        className,
        useTextUnderline ? "--text-underline" : undefined,
        `--color-${String(color || "default").toLowerCase()}`,
        `--margin-top-${marginTop || "default"}`,
        `--size-${String(size || "default").toLowerCase()}`,
        disabled ? "--disabled" : undefined
      )}
    >
      <button
        ref={elementRef}
        disabled={disabled}
        onClick={() => {
          !!onClick && onClick();
        }}
      >
        {!!iconLeft && <CrIcon icon={iconLeft} />}
        <span>{text}</span>
        {!!iconRight && <CrIcon icon={iconRight} />}
      </button>
    </div>
  );
}

HbButton.defaultProps = {
  color: "PRIMARY",
};
